import React, { FC, ReactNode } from "react";
import classNames from "classnames";

import { FieldStatus } from "../../Helpers/FieldStatus";

import { SvgIcon } from "../../../SvgIcon/SvgIcon";
import {UnmountClosed} from "react-collapse";
import { TreatmentsContainerDto } from "@apiModels/TreatmentsContainerDto.csharp";
import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";

type TreatmentSelectProps = {
  treatments: (TreatmentsContainerDto | ServiceContainerDto)[],
  placeholder: Pick<TreatmentsContainerDto, "bookingName" | "description">;
  onSelect: (treatment: TreatmentsContainerDto | ServiceContainerDto) => void;
  status?: FieldStatus;
  error?: {
    message?: string;
  };
  isOpen: boolean;
  toggleOpen: () => void;
  idName: string;
};

export const TreatmentSelect: FC<TreatmentSelectProps> = ({
  treatments,
  placeholder,
  onSelect,
  status = FieldStatus.active,
  error,
  isOpen,
  toggleOpen,
  idName,
}) => {
  const mapOptionsElements = (item: TreatmentsContainerDto | ServiceContainerDto): ReactNode => (
    <li key={item.containerId} >
      <button className="SelectNew__optionBtn" onClick={() => onSelect(item)}>
        <span className="SelectNew__optionName">
          {item.bookingName}
        </span>
        {item.description && <span className="SelectNew__optionDescription">{item.description}</span>}
      </button>
    </li>
  );
  
  return (
    <div
      className={classNames(
        // TODO: New suffix added to avoid conflicts with existing legacy Select component styles. Remove the suffix after the legacy Select component is removed.
        "SelectNew",
        {
          "SelectNew--opened": isOpen,
          "SelectNew--disabled": status == FieldStatus.disabled,
          "SelectNew--error": status == FieldStatus.error,
        }
      )}
    >
      <button
        className="SelectNew__field"
        type="button"
        disabled={status == FieldStatus.disabled}
        onClick={toggleOpen}
        aria-expanded={isOpen}
        aria-controls={`${idName}__section`}
        id={`${idName}__title`}
      >
        <h3 className="SelectNew__fieldLabel">{placeholder.bookingName}</h3>
        {placeholder.description && <span className="SelectNew__fieldDescription">{placeholder.description}</span>}
        {status != FieldStatus.disabled && <SvgIcon iconName="chevron-down" className="SelectNew__icon" />}
      </button>
      
      <UnmountClosed 
          theme={{ collapse: "SelectNew__collapse" }} 
          isOpened={isOpen} 
          id={`${idName}__section`}
          aria-labelled-by={`${idName}__title`}
      >
        <ul className="SelectNew__optionsList">
          {treatments.map(mapOptionsElements)}
        </ul>
      </UnmountClosed>
      
      {status == FieldStatus.error && error && error.message && (
        <span>{error.message}</span>
      )}
    </div>
  );
};
